import styled from 'styled-components';

export const IconButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: middle;
`;
